import React, { useState,useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const AddSystem = (props) => {
  const { isModalSystemOpen, handleModalSystemClose } = props;
  const { addSystem, selectedEntityType, selectedJurisdiction } =
    props.SystemListsScreenStore;
  const { CommonStore } = props;
  const [spSystem, setSpSystem] = useState("");
  const [spActiveStatus, setSpActiveStatus] = useState({
    label: "Active",
    value: 1,
  });
  const [spErrorMessage, setSpErrorMessage] = useState("");
  
  const isDataValid = () => {
    if (spSystem) {
      return true;
    }
    return false;
  };

  const handleAddSystem = () => {
    if (!isDataValid()) {
      setSpErrorMessage("Kindly enter mandatory fields");
      return;
    }
    /* Data update 
      {"SystemName":"Jeeva system 1","SubSystemName":"Jeeva sub system 1","LineName":"Jeeva Line 1","Status":0,"CreatedBy":null,"CreatedDate":null,"UpdatedBy":null,"UpdatedDate":null}
    */
    addSystem(
      {
        SystemName: spSystem,
        Status: spActiveStatus?.value,
      },
      CommonStore
    );
    handleClose();
  };

  const handleClose = () => {
    setSpSystem("");
    setSpActiveStatus({
      label: "Active",
      value: 1,
    });
    setSpErrorMessage("");
    handleModalSystemClose();
  };

  return (
    <div className="add-entity-dialog">
      <Modal show={isModalSystemOpen} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Dig Master Tracker - Add System</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {spErrorMessage && <div className="error-message">{spErrorMessage}</div>}
          <Form>
            <Form.Group className="mb-3" controlId="spSystem">
              <Form.Label>System *</Form.Label>
              <Form.Control
                type="input"
                value={spSystem}
                onChange={(event) => setSpSystem(event.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="spActiveStatus" style={{display:'none'}}>
              <Form.Label>Active/Inactive *</Form.Label>
              <Select
                className="active-status-dropdown"
                options={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 0 },
                ]}
                value={spActiveStatus}
                onChange={(value) => setSpActiveStatus(value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAddSystem}>
            Add
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddSystem;
